module.exports = __webpack_public_path__ + "static/media/ic-arrow-1.8a80617e.svg";